import { getContext } from 'recompose'
import PropTypes from 'prop-types'
import Tooltip from './Tooltip'

const withTheme = getContext({ theme: PropTypes.object })
// Element with injected theme
const themedTooltip = withTheme(Tooltip)

export default Tooltip
export { themedTooltip as Tooltip }



// WEBPACK FOOTER //
// ./ui/Tooltip/index.js